export default __webpack_public_path__ + "static/media/648.ad5eac12.png";